import ApiClient from "../../api/src/ApiClient";

export default {
  namespaced: true,

  state: {
    showBasketModal: false,
    basket: {
      baskets: [],
      mpk_summary_list: []
    }
  },

  mutations: {
    basket(state, response) {
      state.basket = response;
    }
  },

  actions: {
    async addToBasket({ commit, state }, params, notify = true) {
      let result = await ApiClient.post("api/cart/add", params);
      if (notify) {
        this.dispatch("addNotification", {
          key: "newBasketProduct",
          message: params
        });
      }
      commit("basket", result);
    },

    async modifyPosition({ commit, state }, position) {
      let result = await ApiClient.post("api/cart/edit", position);
      commit("basket", result);
    },

    async removePosition({ commit, state }, position) {
      let result = await ApiClient.post("api/cart/remove", position);
      commit("basket", result);
    },

    async data({ commit, state }, params) {
      let result = await ApiClient.get("api/cart");
      commit("basket", result);
    },

    async clearBasket({ commit, state }) {
      await ApiClient.get("api/cart/clear");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/basket/src/BasketStore.js